import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { i18nextPlugin } from "translation-check";

import en from "./translations/en";
import es from "./translations/es";
import it from "./translations/it";
import pt from "./translations/pt";
import { ApplicationLanguage } from "./ApplicationLanguagesEnum";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(i18nextPlugin)
  .init({
    fallbackLng: ApplicationLanguage.ENGLISH,
    load: "all",
    ns: ["common"],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    resources: { en, es, it, pt },
  });

export default i18n;
